import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import { cn } from './cn'

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement>

// 寸法・角丸・border・accent(primary)・focus リングは本コンポーネントが確定する
// （利用側 className での上書きはレイアウト系=margin 等に限定）。
// 既存 LoginPage の `w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary` を BASE へ写像。
const BASE =
  'h-4 w-4 rounded border-gray-300 accent-primary text-primary ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'

/**
 * 真偽選択（チェックボックス）。
 * label 関連付け（<label> ラップ もしくは htmlFor/id）は利用側責務。
 * 寸法・色・focus リングは本コンポーネントが担保。
 */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, ...rest },
  ref,
) {
  return <input ref={ref} type="checkbox" className={cn(BASE, className)} {...rest} />
})
